/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */

import {
  useCallback,
  useEffect,
  useId,
  useRef,
} from 'react';
import modalStyles from '~/styles/modal.module.css';

type Props = {
  title: string;
  description?: string | null;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
};

export default function Modal({
  title,
  description,
  isOpen,
  onClose,
  children,
}: Props) {
  const dialogRef = useRef<HTMLDialogElement>(null);
  const titleId = useId();

  useEffect(() => {
    if (!dialogRef.current) {
      return;
    }

    if (isOpen) {
      dialogRef.current?.showModal();
    } else {
      dialogRef.current?.close();
    }
  }, [isOpen]);

  const onModalClick = useCallback((event: React.MouseEvent<HTMLDialogElement>) => {
    if (event.target === dialogRef.current) {
      onClose();
    }
  }, [onClose]);

  return (
    <dialog
      className={modalStyles.modal}
      aria-modal="true"
      aria-labelledby={titleId}
      ref={dialogRef}
      onClick={onModalClick}
    >
      <div className={modalStyles.modalContent}>
        <h1 id={titleId} className={modalStyles.modalTitle}>
          {title}
        </h1>

        {description && (
          <p className={modalStyles.modalDescription}>
            {description}
          </p>
        )}

        {isOpen && children}

        <button
          type="button"
          className={modalStyles.modalCloseButton}
          onClick={onClose}
        >
          Close
        </button>
      </div>
    </dialog>
  );
}
